import React, { useMemo } from "react";
import { useSelectedResult } from "../../../contexts/SelectedResultContext";
import { useSearch } from "../../../contexts/SearchContext";
import {
  resolveSearchOfferDisplayCurrency,
  formatIlsBasketTotalForDisplay,
} from "../../../utils/searchOfferPriceDisplay";

const TotalPayment = ({ totalPrice, originalCurrency, finalPriceGBP, displayCurrency }) => {
  const { ilsToUsd } = useSelectedResult();
  const { selectedHotelCurrency, searchPhrase } = useSearch();
  const priceInIls =
    totalPrice == null || totalPrice === "" ? NaN : Number(totalPrice);

  const offerDisplayCurrency = useMemo(
    () =>
      displayCurrency ||
      resolveSearchOfferDisplayCurrency({ selectedHotelCurrency, searchPhrase }),
    [displayCurrency, selectedHotelCurrency, searchPhrase]
  );

  const primaryDisplay = useMemo(
    () =>
      formatIlsBasketTotalForDisplay(priceInIls, offerDisplayCurrency, ilsToUsd, {
        ceilIls: true,
      }),
    [priceInIls, offerDisplayCurrency, ilsToUsd]
  );

  if (!Number.isFinite(priceInIls)) {
    return <span>—</span>;
  }

  if (originalCurrency === "GBP" && finalPriceGBP) {
    return (
      <span>
        {Math.round(finalPriceGBP).toLocaleString()} £ ({primaryDisplay})
      </span>
    );
  }

  return <span>{primaryDisplay}</span>;
};

export default TotalPayment;
